import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    firstCardDescription:
      'Deposit your capital online, receive your certificate of deposit within 72 hours and open your pro bank account with Shine. Quick and simple!',
    firstCardHeading: 'Our offer',
    howItWorksButton: 'How it works',
    nextCta: 'Next',
    secondCardDescriptionBullets: [
      'The draft statutes of your company',
      'An ID document (ID card, passport or residence permit)',
    ],
    secondCardHeading: 'What you’ll need',
    temporarilyUnavailable: 'Temporarily unavailable',
  },
  fr: {
    firstCardDescription:
      'Déposez votre capital en ligne, recevez votre attestation de dépôt sous 72 heures et ouvrez votre compte pro avec Shine. C’est simple et rapide\u00A0!',
    firstCardHeading: 'Notre offre',
    howItWorksButton: 'Comment ça marche\u00A0?',
    nextCta: 'Suivant',
    secondCardDescriptionBullets: [
      'Le projet de statuts de votre entreprise',
      'Un document d’identité (carte nationale d’identité, passeport ou titre de séjour)',
    ],
    secondCardHeading: 'De quoi avez-vous besoin\u00A0?',
    temporarilyUnavailable: 'Temporairement indisponible',
  },
} as const);
